import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services/fetchServiceV2';
import { TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

/** @category useFindPw */
export type TypeFindPwParams = {
  /** 로그인 아이디 */
  username: string;
  /** 휴대전화 번호 */
  phoneNumber: string;
  /** 인증번호 */
  verificationCode: string;
};

/** @category useFindPw */
export type TypeFindPwResponse = {
  /** 응답 메시지 */
  message: string;
};

/**
 * @description 비밀번호 초기화 > 인증번호 확인 api에 사용되는 커스텀 훅
 */
export const useFindPw = () => {
  const { mutateAsync } = useMutation({
    mutationFn: (params: TypeFindPwParams) => {
      const endpoint = '/labor-accounts/phone-verification/for-modify-password/verify';
      return axiosInstance.post(endpoint, params, { headers: { withoutToken: true } });
    },
  });

  const requestFindPw = async ({
    params,
    onSuccess,
    onError,
  }: {
    params: TypeFindPwParams;
    onSuccess?: (res: TypeFindPwResponse) => void;
    onError?: (err: TypeErrorFormat) => void;
  }) => {
    requestHelper(() => mutateAsync(params), onSuccess, onError);
  };

  return requestFindPw;
};
